import { Box } from '@mui/material';

export const PulsingDot = ({ testId }: { testId?: string }) => (
  <Box
    data-testid={testId}
    sx={{
      width: 10,
      height: 10,
      borderRadius: '50%',
      bgcolor: 'text.secondary',
      animation: 'idp-pulse 1s ease-in-out infinite',
      '@keyframes idp-pulse': {
        '0%, 100%': { opacity: 0.2 },
        '50%': { opacity: 1 },
      },
    }}
  />
);
